import { useState } from "react";
import { useSelector } from "react-redux";
import { documentHasFileId } from "../../lib/docs";
import { getExportDownloadLink } from "../../lib/fetchApi";
import { retriveWorkQNameFromID } from "../../lib/misc";
import { formatDateLocalWithTime } from "../../lib/script";

export default function ExportsRow({data}) {
    const userToken = useSelector(state => state.user.token)
    const [downloading, setDownloading] = useState(false)

    async function downloadHandler(e) {
        e.preventDefault()
        if (!userToken || !data?.id || downloading) {
            return
        }
        setDownloading(true)
        try {
            const response = await getExportDownloadLink(userToken, data.id)
            const downloadUrl = response?.download_url
            if (downloadUrl) {
                const win = window.open(downloadUrl)
                if (win) {
                    win.focus()
                }
            }
        } finally {
            setDownloading(false)
        }
    }

    return <tr>
       
        <td>{formatDateLocalWithTime(data.created_at)}</td>
        {/* <td>{data.user?.name}</td> */}
        <td>{data.work_queue_id ? retriveWorkQNameFromID(data.work_queue_id) : data.name}</td>
        <td>{data.is_exported && documentHasFileId(data) ? 
        <>
            <a href="#" onClick={downloadHandler} style={downloading ? { opacity: 0.6, pointerEvents: 'none' } : undefined}>
                <i className={downloading ? 'ti ti-loader' : 'ti ti-download'}></i> {downloading ? 'Preparing…' : 'Download File'}
            </a>
        </>
        :
        <>
            <i className="ti ti-progress-alert"></i> in progress
        </>}</td>
        <td>{data.is_exported ? 
        <>
            {data.record_count}
        </>
        :
        <>
            <i className="ti ti-progress-alert"></i> in progress
        </>}</td>
    </tr>
}
